export type AppVariant = 'default' | 'demo';

const DEMO_HOSTS = new Set([
  'demo.lionshare.co',
  'localhost',
  '127.0.0.1',
  '[::1]',
]);

export function isDemoHost(hostname: string): boolean {
  const normalizedHostname = hostname.trim().toLowerCase();
  return DEMO_HOSTS.has(normalizedHostname);
}

export function resolveAppVariant(rawVariant: string | undefined, hostname: string): AppVariant {
  const requestedVariant = rawVariant?.trim().toLowerCase();
  return requestedVariant === 'demo' && isDemoHost(hostname) ? 'demo' : 'default';
}

const browserHostname = typeof window === 'undefined' ? '' : window.location.hostname;

export const isDemoVariant = import.meta.env.VITE_APP_VARIANT !== undefined
  && import.meta.env.VITE_APP_VARIANT.trim().toLowerCase() === 'demo'
  && isDemoHost(browserHostname);

export const DEMO_STORAGE_PREFIX = 'lionshare-demo';
